import React from 'react'
import { useTranslation } from 'react-i18next'

import Text from '@/components-latest/primitives/Text'

import Styles from './EmptyBillingPage.module.scss'

const EmptyBillingPage = () => {
  const { t } = useTranslation()
  return (
    <div className={Styles.message} data-testid="empty-billing">
      <img
        className={Styles.imageForEmpty}
        src="/images/empty-performance.svg"
        alt="Waiting for billing"
      />
      <Text variant="title-3" gutter={8} align="center">
        {t('billing.no-data-title')}
      </Text>
      <Text variant="subtitle" className={Styles.dimmed} align="center">
        {t('billing.no-data-subtitle')}
      </Text>
    </div>
  )
}

export default EmptyBillingPage
